import {
  AGREE_DISAGREE_TYPES,
  INTAKE_SYMPTOM_DETAIL_QUESTIONS_RADIO_GROUP_VALUES,
  YES_NO_NA_TYPES,
  YES_NO_NOT_SURE_TYPES,
  YES_NO_PREFER_NOT_TO_SAY_TYPES,
} from "./data";

export const YesNoNA = [
  YES_NO_NA_TYPES.yes,
  YES_NO_NA_TYPES.no,
  YES_NO_NA_TYPES.na,
] as const;

export const AgreeDisagree = [
  AGREE_DISAGREE_TYPES.agree,
  AGREE_DISAGREE_TYPES.disagree,
] as const;

export const YesNoNotSure = [
  YES_NO_NOT_SURE_TYPES.yes,
  YES_NO_NOT_SURE_TYPES.no,
  YES_NO_NOT_SURE_TYPES.notSure,
] as const;

export const yesNoPreferNotToSay = [
  YES_NO_PREFER_NOT_TO_SAY_TYPES.yes,
  YES_NO_PREFER_NOT_TO_SAY_TYPES.no,
  YES_NO_PREFER_NOT_TO_SAY_TYPES.prefer_not_to_say,
] as const;

export const RadioGroupTrendOptions = [
  INTAKE_SYMPTOM_DETAIL_QUESTIONS_RADIO_GROUP_VALUES.steady,
  INTAKE_SYMPTOM_DETAIL_QUESTIONS_RADIO_GROUP_VALUES.getting_better,
  INTAKE_SYMPTOM_DETAIL_QUESTIONS_RADIO_GROUP_VALUES.getting_worse,
] as const;

export const RadioGroupNatureOfEpisodesOptions = [
  INTAKE_SYMPTOM_DETAIL_QUESTIONS_RADIO_GROUP_VALUES.intermittent_and_fully_better_between_episodes,
  INTAKE_SYMPTOM_DETAIL_QUESTIONS_RADIO_GROUP_VALUES.intermittent_and_not_fully_better_between_episodes,
] as const;

export const RadioGroupFrequencyOptions = [
  INTAKE_SYMPTOM_DETAIL_QUESTIONS_RADIO_GROUP_VALUES.less_frequent_episodes,
  INTAKE_SYMPTOM_DETAIL_QUESTIONS_RADIO_GROUP_VALUES.more_frequent_episodes,
  INTAKE_SYMPTOM_DETAIL_QUESTIONS_RADIO_GROUP_VALUES.unpredictably_variable,
] as const;

export const intakeRadioOptions = [
  ...YesNoNA,
  ...YesNoNotSure,
  ...AgreeDisagree,
  ...yesNoPreferNotToSay,
] as const;

export type IntakeOptionsValues = (typeof intakeRadioOptions)[number];

export type YesNoNAType = typeof YesNoNA;

export type YesNoNotSureType = typeof YesNoNotSure;

export type AgreeDisagreeType = typeof AgreeDisagree;

export type RadioGroupTrendType = typeof RadioGroupTrendOptions;

export type YesNoPreferNotToSayOptions = typeof yesNoPreferNotToSay;

export type RadioGroupNatureOfEpisodesType =
  typeof RadioGroupNatureOfEpisodesOptions;

export type RadioGroupFrequencyType = typeof RadioGroupFrequencyOptions;

export type IntakeRadioValues =
  | YesNoNAType
  | YesNoNotSureType
  | AgreeDisagreeType
  | YesNoPreferNotToSayOptions;

export type RadioGroupValues =
  | RadioGroupTrendType
  | RadioGroupNatureOfEpisodesType
  | RadioGroupFrequencyType;
